// Docker and hosted builds provide VITE_API_URL explicitly. Keep a production
// fallback so authentication never redirects users to the local-only hostname.
export const API_URL = import.meta.env.VITE_API_URL || 'https://d6vhiw9w85.execute-api.us-east-1.amazonaws.com'
